// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createCustomError } from "@nevware21/ts-utils";
var otelErrorType;
/*#__NO_SIDE_EFFECTS__*/
export function getOpenTelemetryError() {
    if (!otelErrorType) {
        otelErrorType = createCustomError("OpenTelemetryError", function (self, args) {
        });
    }
    return otelErrorType;
}
export function throwOTelError(message) {
    throw new (getOpenTelemetryError())(message);
}
//# sourceMappingURL=OTelError.js.map